
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4dfVD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d4bbb1bd159b180c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $d4bbb1bd159b180c$export$2e2bcd8739ae039 = {
    'people.menu.renotify.flag.description': "Vi sender alle en e-mail med en p\xe5mindelse. Det kan tage op til et minut.",
    'people.menu.renotify.flag.description.confluence': "P\xe5mind teammedlemmer",
    'people.menu.renotify.flag.title': "Sender p\xe5mindelser",
    'people.menu.renotify.flag.title.confluence': 'Sender invitations-e-mail igen',
    'people.menu.renotify.menu.description': "{userCount, plural, one {{userCount,number} person har ikke accepteret sin invitation til {product}. Se, hvem der mangler, og send dem en p\xe5mindelse.} other {{userCount,number} personer har ikke accepteret deres invitation til {product}. Se, hvem der mangler, og send dem en p\xe5mindelse.}}",
    'people.menu.renotify.menu.description.confluence': "Nogle personer har ikke accepteret deres invitation til Confluence. Se, hvem der mangler, og send dem en p\xe5mindelse.",
    'people.menu.renotify.menu.dismiss': 'Luk',
    'people.menu.renotify.menu.dismiss.confluence': 'Ikke nu',
    'people.menu.renotify.menu.remind': "P\xe5mind teammedlemmer",
    'people.menu.renotify.menu.remind.confluence': "P\xe5mind teammedlemmer",
    'people.menu.renotify.menu.title': 'Er alle med?',
    'people.menu.renotify.modal.copied': 'Linket blev kopieret',
    'people.menu.renotify.modal.copy': "Kopi\xe9r invitationslink",
    'people.menu.renotify.modal.description': "Vi kan sende en e-mail med en p\xe5mindelse til de manglende medlemmer, eller ogs\xe5 kan du selv dele invitationslinket.",
    'people.menu.renotify.modal.description.confluence': "Send invitations-e-mailen igen, eller kopi\xe9r og del invitationslinket.",
    'people.menu.renotify.modal.dismiss': 'Annuller',
    'people.menu.renotify.modal.resend': "Send p\xe5mindelse",
    'people.menu.renotify.modal.resend.confluence': 'Send invitation igen',
    'people.menu.renotify.modal.title': "Send p\xe5mindelser til manglende medlemmer",
    'people.menu.renotify.modal.title.confluence': "P\xe5mind manglende teammedlemmer",
    'ptc.pm.collaborators.title': 'Dine samarbejdspartnere',
    'ptc.pm.error-heading': 'Noget gik galt',
    'ptc.pm.error-image-alt-text': "En robot, der er g\xe5et i stykker, og en masse mennesker, der har travlt med at reparere den.",
    'ptc.pm.error-text': "Vi holder \xf8je med disse fejl, men kontakt os endelig, hvis det ikke hj\xe6lper at opdatere siden",
    'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} medlem} other {{memberCount,number} medlemmer}}',
    'ptc.pm.people': 'Personer',
    'ptc.pm.teams': 'Teams',
    'ptc.pm.view-your-profile': 'Vis din profil',
    'ptc.pm.your-teams.title': 'Dine teams'
};

});


//# sourceMappingURL=da.c77334a2.js.map
